module.exports = "/assets/earth-poster-pink.jpg?Fxm+JP3";